module.exports = __webpack_public_path__ + "img/5.74a35565.png";